import { Component, Input } from '@angular/core';
import { PagePerformanceAuditService } from '../../services/page-performance-audit/page-performance-audit.service';
import { ExporterService } from '../../../export/services/exporter.service';

@Component({
    selector: 'page-performance-dialogs-audit-details',
    standalone: false,
    template: `
        <div class="mon-dialog-header">
            <div class="outer-t-smurf">
                <page-header [header]="'Audit Details'" panelLeftClass="col-40 mt-1">
                <page-header-content>
                    <div class="row">
                        <div class="col-auto ml-auto pr-1">
                            <button type="button"
                                    class="btn btn-border-radius btn-secondary export-btn-height mr-1 font-size-1-1"
                                    ngCsv
                                    [data]="exportCsv()"
                                    [quoteStrings]="true"
                                    fieldSep=";"
                                    [filename]="audit?.id + '.csv'"
                                    [disabled]="isExportDisabled()"
                                    [attr.aria-label]="'Export CSV'">
                                    <span class="fas fa-download fa-lg" aria-hidden="true"></span>
                            </button>
                        </div>
                    </div>
                </page-header-content>
            </page-header>
            </div>
        </div>
        <div class="mon-dialog-body bg-white">
            <div class="mt-4 mx-4">
                <page-performance-audit-display-binary *ngIf="scoreDisplayModeIsBinary()" [audit]="audit">
                </page-performance-audit-display-binary>
                <page-performance-audit-display-informative *ngIf="scoreDisplayModeIsInformative()" [audit]="audit">
                </page-performance-audit-display-informative>
                <page-performance-audit-display-manual *ngIf="scoreDisplayModeIsManual()" [audit]="audit">
                </page-performance-audit-display-manual>
                <page-performance-audit-display-not-applicable *ngIf="scoreDisplayModeIsNotApplicable()" [audit]="audit">
                </page-performance-audit-display-not-applicable>
                <page-performance-audit-display-numeric *ngIf="scoreDisplayModeIsNumeric() || scoreDisplayModeIsMetricSavings()" [audit]="audit">
                </page-performance-audit-display-numeric>
            </div>
        </div>
    `,
})
export class PagePerformanceDialogsAuditDetailsComponent {
    @Input() audit: any;

    constructor (
        private pagePerformanceAuditService: PagePerformanceAuditService,
        private exporterService: ExporterService,
    ) {}

    scoreDisplayModeIsNumeric (): boolean {
        return this.pagePerformanceAuditService.scoreDisplayModeIsNumeric(this.audit.scoreDisplayMode);
    }

    scoreDisplayModeIsBinary (): boolean {
        return this.pagePerformanceAuditService.scoreDisplayModeIsBinary(this.audit.scoreDisplayMode);
    }

    scoreDisplayModeIsManual (): boolean {
        return this.pagePerformanceAuditService.scoreDisplayModeIsManual(this.audit.scoreDisplayMode);
    }

    scoreDisplayModeIsInformative (): boolean {
        return this.pagePerformanceAuditService.scoreDisplayModeIsInformative(this.audit.scoreDisplayMode);
    }

    scoreDisplayModeIsNotApplicable (): boolean {
        return this.pagePerformanceAuditService.scoreDisplayModeIsNotApplicable(this.audit.scoreDisplayMode);
    }

    scoreDisplayModeIsMetricSavings (): boolean {
        return this.pagePerformanceAuditService.scoreDisplayModeIsMetricSavings(this.audit.scoreDisplayMode);
    }

    isExportDisabled (): boolean {
        const itemsLength = (this.audit?.details?.items?.length || 0);
        const chainsLength = this.audit?.details?.chains?.[0]?.children
            ? Object.keys(this.audit.details.chains[0].children).length : 0;
        return itemsLength < 1 && chainsLength < 1;
    }

    exportCsv (): any {
        return () => {
            if (this.audit && this.audit.details && this.audit.details.items) {
                return this.exporterService.parsePerformanceAuditsDetails(this.audit.details.items);
            } else if (this.audit && this.audit.details && this.audit.details.chains) {
                let result: any[] = [];
                Object.keys(this.audit.details.chains).forEach((key) => {
                    result = result.concat(
                        this.exporterService.parsePerformanceAuditsDetails(
                            Object.keys(this.audit.details.chains[key].children).map((childKey) => {
                                return this.audit.details.chains[key].children[childKey];
                            }),
                        ),
                    );
                });
                return result;
            } else {
                return null;
            }
        };
    }
}
